"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var ProfileGate_less_1 = __importDefault(require("./ProfileGate.less"));
// 4-digit masked field, same look as the login form inputs.
var PinInput = function (_a) {
    var _b;
    var value = _a.value, onChange = _a.onChange, invalid = _a.invalid, disabled = _a.disabled, autoFocus = _a.autoFocus, onSubmit = _a.onSubmit;
    return (react_1.default.createElement(components_1.TextInput, { className: (0, classnames_1.default)(ProfileGate_less_1.default['text-input'], ProfileGate_less_1.default['pin-input'], (_b = {}, _b[ProfileGate_less_1.default['invalid']] = invalid, _b)), type: 'password', inputMode: 'numeric', autoComplete: 'off', placeholder: '••••', autoFocus: autoFocus, disabled: disabled, value: value, onChange: function (event) { return onChange(event.target.value.replace(/\D/g, '').slice(0, 4)); }, onSubmit: onSubmit }));
};
exports.default = PinInput;
